import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { logos, socialMediaUrl } from '../Details';

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const { linkdein, instagram } = socialMediaUrl;
  const toggleClass = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className='container mx-auto md:flex justify-between py-2 max-width'>
      <div className='flex justify-between items-center py-2 md:py-10'>
        <NavLink to='/'>
          <img className='w-14' src={logos.logogradient} alt='logo' />
        </NavLink>
        <div onClick={toggleClass} className='cursor-pointer'>
          <svg
            className='stroke-dark-heading dark:stroke-white md:hidden'
            width='25'
            height='20'
            viewBox='0 0 16 13'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              d='M1.4375 1.3125H14.5625M1.4375 11.3125H14.5625H1.4375ZM1.4375 6.3125H14.5625H1.4375Z'
              strokeWidth='1.875'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </svg>
        </div>
      </div>
      <nav className={` ${!isOpen ? 'hidden' : null} text-center md:flex justify-between`}>
        <ul className='dark:text-light-content font-medium md:flex items-center md:space-x-5 md:mr-10'>
          <li className='pb-1 md:pb-0'>
            <NavLink to='/' onClick={toggleClass}>
              Home
            </NavLink>
          </li>
          <li className='pb-1 md:pb-0'>
            <NavLink to='/about' onClick={toggleClass}>
              About
            </NavLink>
          </li>
          <li className='pb-1 md:pb-0'>
            <NavLink to='/technologies' onClick={toggleClass}>
              Technologies
            </NavLink>
          </li>
          <li className='pb-1 md:pb-0'>
            <NavLink to='/projects' onClick={toggleClass}>
              Projects
            </NavLink>
          </li>
          <li>
            <NavLink to='/contact' onClick={toggleClass}>
              Contact
            </NavLink>
          </li>
        </ul>
        <ul className='flex justify-evenly items-center my-5 md:my-0 md:space-x-5 md:mr-5'>
          <li>
            <a href={instagram} target='_blank' rel='noreferrer noopener'>
              <svg
                className='dark:fill-light-heading fill-dark-heading'
                width='32'
                height='32'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 448 512'>
                <path d='M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z' />
              </svg>
            </a>
          </li>
          <li>
            <a href={linkdein} target='_blank' rel='noreferrer noopener'>
              <svg
                className='dark:fill-light-heading fill-dark-heading'
                width='30'
                height='30'
                viewBox='0 0 30 30'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path d='M15 0.599976C7.04701 0.599976 0.600006 7.04698 0.600006 15C0.600006 22.953 7.04701 29.4 15 29.4C22.953 29.4 29.4 22.953 29.4 15C29.4 7.04698 22.953 0.599976 15 0.599976ZM11.475 20.9685H8.55901V11.5845H11.475V20.9685ZM9.99901 10.4325C9.07801 10.4325 8.48251 9.77997 8.48251 8.97297C8.48251 8.14948 9.09601 7.51648 10.0365 7.51648C10.977 7.51648 11.553 8.14948 11.571 8.97297C11.571 9.77997 10.977 10.4325 9.99901 10.4325ZM22.125 20.9685H19.209V15.768C19.209 14.5575 18.786 13.7355 17.7315 13.7355C16.926 13.7355 16.4475 14.292 16.236 14.8275C16.158 15.018 16.1385 15.288 16.1385 15.5565V20.967H13.221V14.577C13.221 13.4055 13.1835 12.426 13.1445 11.583H15.678L15.8115 12.8865H15.87C16.254 12.2745 17.1945 11.3715 18.768 11.3715C20.6865 11.3715 22.125 12.657 22.125 15.42V20.9685Z' />
              </svg>
            </a>
          </li>
          <li>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
